import { Modal } from "ant-design-vue";
import { defineStore } from "pinia";
import { ref } from "vue";
import { useUserStore } from "./user";

export const useAccessDeniedStore = defineStore("accessDenied", () => {
  const visible = ref(false);
  const message = ref("");
  const lastShowTime = ref(0);
  const SHOW_INTERVAL = 5000; // 5秒内不重复显示
  const userStore = useUserStore();
  const showAccessDenied = (customMessage?: string) => {
    const currentTime = Date.now();
    if (currentTime - lastShowTime.value < SHOW_INTERVAL) {
      return;
    }

    message.value = customMessage || "当前 ip 地址不在允许范围内，请在指定 ip 下使用！";
    visible.value = true;
    lastShowTime.value = currentTime;

    Modal.error({
      title: "访问受限",
      content: message.value,
      wrapClassName:'new-confirm-modal',
      icon:null,
      centered:true,
      zIndex:3000,
      async onOk() {
        hideAccessDenied();
        // 退出当前账号，跳转登录页面
        await userStore.logout({ source: "access_denied_modal" });
      }
    });
  };

  const hideAccessDenied = () => {
    visible.value = false;
    lastShowTime.value = Date.now(); // 关闭时也更新最后显示时间
  };

  return {
    visible,
    message,
    showAccessDenied,
    hideAccessDenied
  };
});
